import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('AUTHORIZED_ROUTE', LOG_LEVELS.ERROR);

class AuthorizedRoute extends Route {

  render() {
    if (this.props.hideMatches || !this.props.showMatches) {
      return (<Redirect to={this.props.redirectTo}/>);
    }
    return super.render();
  }
}
function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state, props);

  let myRoles = (state.authentication && state.authentication.data && state.authentication.data.products) || [];
  //To be removed just for testing, used as a fallback data
  // || (state.authentication && state.authentication.products && state.authentication.products.map((e) => e.description))
  // || [];
  log.debug('mapStateToProps: myRoles: ', myRoles);
  log.debug('mapStateToProps: props: ', props);
  const hide = (props.hide && Array.isArray(props.hide) ? props.hide : [props.show]) || [];
  const grey = (props.grey && Array.isArray(props.grey) ? props.grey : [props.grey]) || [];
  const show = (props.show && Array.isArray(props.show) ? props.show : [props.show]) || [];

  const hideMatches = hide.filter((role) => {return myRoles.indexOf(role) >= 0;}).length > 0;
  const greyMatches = grey.filter((role) => {return myRoles.indexOf(role) >= 0;}).length > 0;
  const showMatches = show.length <= 0 || show.filter((role) => {return myRoles.indexOf(role) >= 0;}).length > 0;


  return {
    hideMatches,
    greyMatches,
    showMatches,
    myRoles,
  };
}

/**
 *
 * Precedence:
 * hide beats grey beats show.
 *
 */
AuthorizedRoute.defaultProps = {
  hide: [],
  grey: [],
  show: [],
  redirectTo: '/notAllowed'

};

export default connect(mapStateToProps)(AuthorizedRoute);
